<template>
  <div class="container-app">
    <AppHeader />
    <div class="body">
      <SideBar @update:view-container-margin="setContainerMargin" />
      <div class="wrapper" :style="containerMargin">
        <nav class="breadcrumb has-arrow-separator" aria-label="breadcrumbs">
          <ul>
            <li v-for="(breadcrumb, index) in getBreadcrumbsList" :key="index">
              <routerLink
                v-if="
                  Boolean(breadcrumb.path) && index < getBreadcrumbs.length - 1
                "
                class="linked spacing-pt-5"
                role="link"
                rel="search tag"
                :to="breadcrumb.path"
              >
                {{ breadcrumb.name }}
              </routerLink>
              <span v-else class="spacing-pt-5">
                {{ breadcrumb.name }}
              </span>
            </li>
          </ul>
        </nav>
        <router-view :key="$route.fullPath" class="view-container" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";

import AppHeader from "@/layout/AppHeader";

import SideBar from "@/views/App/Menu/SideBar.vue";

import { General } from "@/utils/constants";
import {
  SCREENS,
  SIZES as sizes,
  NOTIFICATION_PDF_TITLE,
  NOTIFICATION_NEW_VIEW_PDF
} from "@/utils/enumerate";

import ModalNotification from "@/views/App/ModalNotification";

export default {
  name: "AppHome",
  components: {
    SideBar,
    AppHeader
  },

  data() {
    return {
      General,
      SCREENS,
      containerMargin: {},
      storageKey: "CHANGE_PDF_VIEWER"
    };
  },

  computed: {
    ...mapGetters({
      getBreadcrumbs: "getBreadcrumbs",
      isAuthenticated: "isAuthenticated",
      socketConnectionState: "socketConnectionState",
      getCurrentTabProcessPanel: "getCurrentTabProcessPanel",
      getCurrentTabProcessDetails: "getCurrentTabProcessDetails",
      mobileSize: "mobileSize"
    }),

    getBreadcrumbsList() {
      if (this.mobileSize !== sizes.IS_LARGE)
        return this.getBreadcrumbs.slice(-2);
      return this.getBreadcrumbs;
    }
  },

  watch: {
    socketConnectionState(newState) {
      newState && this.sendSocketMessage(this.isAuthenticated);
    }
  },

  async created() {
    window.addEventListener("resize", this.onResize);
    this.checkBroadcastSocket();
    const config = JSON.parse(localStorage.getItem("PERSON_CONFIG"));
    config && this.setConfig(config);
    this.onResize();
    // Notice disabled
    const noticeModalCount = Number(2 || localStorage.getItem(this.storageKey));

    if (!noticeModalCount || noticeModalCount < 2) {
      this.$buefy.modal.open({
        parent: this,
        component: ModalNotification,
        props: {
          buttonLabel: General.LEARN_MORE,
          noticeTitle: NOTIFICATION_PDF_TITLE,
          bodyHtml: NOTIFICATION_NEW_VIEW_PDF,
          callback: this.moreDetails
        },
        hasModalCard: true,
        trapFocus: true,
        canCancel: false
      });
      const count = noticeModalCount ? noticeModalCount + 1 : 1;
      localStorage.setItem(this.storageKey, count);
    }
  },

  destroyed() {
    window.removeEventListener("resize", this.onResize);
    this.$disconnect();
  },

  methods: {
    ...mapActions({
      sendSocketMessage: "sendSocketMessage",
      fetchBroadcast: "fetchBroadcast",
      checkExistOpenSocket: "checkExistOpenSocket"
    }),
    ...mapMutations({
      setConfig: "setConfig",
      setScreen: "setScreen"
    }),
    setContainerMargin(style) {
      this.containerMargin = style;
    },
    onResize() {
      this.setScreen(window.innerWidth);
    },
    async connectToSocket() {
      await this.$connect();
    },
    moreDetails() {
      window.open(
        "https://drive.google.com/file/d/1qMXH-bqLLzhWeq0czBpwXZlrePocJhYg/view?usp=drive_link",
        "_blank",
        "noopener"
      );
    },
    async checkBroadcastSocket() {
      const result = await this.fetchBroadcast({
        message: { service: "get_master" }
      });
      if (result.error) {
        this.connectToSocket();
      }
      this.checkExistOpenSocket({
        connectToSocket: this.connectToSocket,
        masterSocketExists: !result.error
      });
    }
  }
};
</script>

<style scoped lang="scss">
@import "../assets/scss/variables";

.view-container {
  margin: 0px;

  @media screen and (max-width: 768px) {
    margin-bottom: 50px;
  }
}

.wrapper {
  padding: 20px;
  display: flex;
  flex-flow: column wrap;
  width: 100%;

  @media screen and (max-width: 768px) {
    padding: 10px;
  }
}

.container-app {
  padding: 0;
  margin: 0;
  display: flex;
  flex-flow: column wrap;
  min-height: 100vh;
}
.body {
  display: flex;
  flex-flow: row;
  z-index: 0;
  margin-top: 85px;
}

.breadcrumb {
  margin-left: 15px;
  display: flex;
  flex-direction: row;
  align-items: center;
  font-weight: 600;

  ::before {
    margin: 0 10px;
  }

  @media screen and (max-width: $tablet) {
    margin-left: 0;
    ::before {
      margin: 0 5px;
    }
  }

  .linked {
    cursor: pointer;
    padding: 0;
    color: $title-color;
    &:hover {
      color: $primary;
    }
  }
}
</style>
